import React, { Component } from 'react';
import Alert from 'react-bootstrap/Alert';

import './ContentAlert.css';


class ContentAlert extends Component {
  render() {
    return <div className='ContentAlert'>
      {(this.props.title || this.props.message) && <Alert variant={this.props.variant || 'primary'}>
          {this.props.title && <strong
            className='AlertTitle'
            >{this.props.title}</strong>}
          <span
            className='AlertMessage'
            dangerouslySetInnerHTML={{__html: this.props.message}}
          />
        </Alert>}
    </div>
  }
}

export default ContentAlert;
